import forge from 'node-forge';

import { clientConfig } from '@/config/clientConfig';

export const MAX_UPLOAD_FILES_COUNT = 50;
export const USERNAME_MIN_LENGTH = 4;
export const USERNAME_MAX_LENGTH = 64;
export const inboxEmailRe = /^[a-zA-Z0-9](?:[._+-]?[a-zA-Z0-9]+)*$/;

export const generateRandomEmail = (length: number = 16) => {
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const cryptoObject = window.crypto;

  const randomValues = new Uint32Array(length);
  cryptoObject.getRandomValues(randomValues);

  return Array.from(randomValues)
    .map((value) => characters[value % characters.length])
    .join('');
};

export const getEmailSfx = () => {
  return `@${clientConfig.inboxEmailDomain}`;
};

export const createEmailPassword = () => forge.util.encode64(forge.random.getBytesSync(32));
